module.exports = __webpack_public_path__ + "static/media/wordmark-logo.15a2efa8.svg";